export default function modalCustomStyle({
  isMobile,
  width = 781,
  height = 255,
  ...props
}) {
  return {
    width: isMobile ? '80%' : width,
    height: isMobile ? 'auto' : height,
    borderRadius: isMobile ? 8 : 'unset',
    transform: isMobile ? 'translate(-50%, -50%)' : 'unset',
    top: isMobile ? '50%' : 0,
    left: isMobile ? '50%' : 0,
    right: isMobile ? 'unset' : 0,
    bottom: isMobile ? 'unset' : 0,
    ...props
  };
}